import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { getActiveProduct, PRODUCTS } from '../config/productConfig';

/**
 * Hook that returns the active product config based on the current URL.
 * For global pages (settings, support), falls back to the last active product.
 */
export function useActiveProduct() {
  const { pathname } = useLocation();
  const lastProductRef = useRef('surface');

  const productId = getActiveProduct(pathname);

  if (productId) {
    lastProductRef.current = productId;
  }

  const activeId = productId || lastProductRef.current;
  return PRODUCTS[activeId];
}
